import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useGetTasksQuery } from "../../features/tasks/taskApi";
import Error from "../ui/loaders/Error";
import GlobalLoader from "../ui/loaders/GlobalLoader";
import TaskItem from "./TaskItem";

const TaskList = () => {
  const { data: tasks, isLoading, isError } = useGetTasksQuery();
  const { projects } = useSelector((state) => state.projects);
  const { query } = useSelector((state) => state.tasks);

  const filteredTasks = tasks?.filter((task) =>
    projects?.includes(task.project.projectName)
  );

  const filteredTasksByQuery = filteredTasks?.filter((task) => {
    const taskName = task.taskName.toLowerCase();
    const queryName = query.toLowerCase();
    return taskName.includes(queryName);
  });

  if (isLoading) {
    return <GlobalLoader />;
  }
  if (isError) {
    return <Error />;
  }
  return (
    <div className="lg:pl-[16rem] 2xl:pl-[23rem]">
      <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
        <div className="justify-between mb-10 space-y-2 md:flex md:space-y-0">
          <Link to="/addtask" className="lws-addnew group">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-6 h-6 group-hover:text-indigo-500"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 4.5v15m7.5-7.5h-15"
              />
            </svg>
            <span className="group-hover:text-indigo-500">Add New</span>
          </Link>
        </div>
        <div className="lws-task-list">
          {filteredTasksByQuery?.map((task) => (
            <TaskItem key={task.id} task={task} />
          ))}
        </div>
      </main>
    </div>
  );
};

export default TaskList;
